import script from "./UploadImageGuid.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadImageGuid.vue?vue&type=script&lang=ts&setup=true"

import "./UploadImageGuid.vue?vue&type=style&index=0&id=27735651&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27735651"]])

export default __exports__